import { Concorrente } from '../types/concorrenti/concorrente';
import { ApiService } from './apiService';
import { ENDPOINTS } from '../config/apiConfig';
import { ApiResponse } from '../types/apiResponse';

export class ConcorrentiService {
  static async getConcorrentiList(
    pageNumber = 1,
    pageSize = 10,
    fullName?: string,
    orderBy?: "FirstName" | "LastName" | "Email",
    desc?: boolean,
    discipline?: number
  ): Promise<ApiResponse<Concorrente>> {
    let query = `?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (discipline) query += `&discipline=${discipline}`;
    if (fullName) {
      query += `&fullName=${encodeURIComponent(fullName)}`;
    }
    if (orderBy) {
      query += `&orderBy=${orderBy}`;
    }
    if (desc) {
      query += `&desc=true`;
    }
    return ApiService.client.get<ApiResponse<Concorrente>>(ENDPOINTS.CONCORRENTI.LIST + query);
  }

  static async getAll(): Promise<Concorrente[]> {
    return ApiService.client.get<Concorrente[]>(ENDPOINTS.CONCORRENTI.ALL);
  }

  static async getConcorrenteById(id: number): Promise<Concorrente> {
    return ApiService.client.get<Concorrente>(ENDPOINTS.CONCORRENTI.GET_BY_ID(id));
  }

  static async createConcorrente(concorrente: Omit<Concorrente, 'id'>): Promise<Concorrente> {
    return ApiService.client.post<Concorrente>(ENDPOINTS.CONCORRENTI.CREATE, concorrente);
  }

  static async updateConcorrente(id: number, concorrente: Partial<Concorrente>): Promise<Concorrente> {
    return ApiService.client.put<Concorrente>(ENDPOINTS.CONCORRENTI.UPDATE(id), concorrente);
  }

  static async deleteConcorrente(id: number): Promise<void> {
    return ApiService.client.delete<void>(ENDPOINTS.CONCORRENTI.DELETE(id));
  }
}